<div class="menu-bar-container">
  <div class="menu-bar">
    <div class="nav-left">
      <button routerLinkActive="active" class="nav-button">
        <div class="nav-button__home" routerLink="projects">
          <tngh-svg-icon class="home-icon" name="house" size="lg"></tngh-svg-icon>
          <span>Projecten</span>
        </div>
        @for (breadcrumb of breadcrumbs(); track $index ) {
          <span class="nav-button__sub-page">> {{ breadcrumb.label }}</span>
        }
      </button>
    </div>
    <div class="nav-right">
      <button class="nav-button" (click)="logout()">
        <tngh-svg-icon class="logout-icon" name="logout" size="lg"></tngh-svg-icon>
        Uitloggen
      </button>
    </div>
  </div>
</div>
<div class="elaad-content-container" [class.full-width]="displayFullWidth()">
  <router-outlet></router-outlet>
</div>
